import { useEffect } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Skills from "./components/Skills";
import Education from "./components/Education";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Backtop  from "./components/Backtop";

function App() {
  useEffect(() => {
    // Make all fade-in sections visible on mount
    document.querySelectorAll(".fade-in").forEach((el) => {
      el.classList.add("visible");
    });
  }, []);

  return (
    <div className="dark-theme">
      <main>
      <Header />
        <Hero />
        <About />
        <Skills />
        <Education />
        <Projects />
        <Contact />
      <Backtop />
      </main>
      <Footer />
    </div>
  );
}

export default App;